import { getPersona } from "@/shared/brand/persona";


/**
 * 军师等待指示器的提示语(见 `ui/ThinkingIndicator.tsx` 头注)。
 *
 * ★只许说「在想 / 还在想 / 快好了」这类**不可能为假**的话 —— 指示器与后端真实进度无关,
 *   它不知道这一轮有没有用知识库、有没有在出图;谎报具体步骤会被用户当场戳穿。
 */

/** 已等 N 秒 → 提示语。阈值是体感值:4s 内不换(多数短回复根本看不到第二句)。 */
export function thinkingHintFor(elapsedSec: number, name = getPersona().title): string {
  if (elapsedSec < 4) return `${name}思考中`;
  if (elapsedSec < 10) return "还在想,马上好";
  if (elapsedSec < 20) return "这个问题有点复杂,再给我几秒";
  return "快好了,别走开";
}
